// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { disposeMesh } from 'src/utils/object3DHelpers';
import { Inputs, SceneComponent, ComponentInteractionType } from './types';

export class PatchComponent extends SceneComponent {
  private root: any = null;

  private pivot: any = null;

  private plane: any = null;

  inputs: Inputs = {
    url: null,
    opacity: 1,
  };

  // setting which events are compatible with the component
  events = {
    [ComponentInteractionType.CLICK]: false,
    [ComponentInteractionType.HOVER]: false,
    [ComponentInteractionType.DRAG]: false,
  };

  onInit() {
    const THREE = this.context.three;
    this.root = new THREE.Object3D();
    this.pivot = new THREE.Object3D();
    this.pivot.rotation.x = -Math.PI / 2;
    this.root.add(this.pivot);
    this.outputs.objectRoot = this.root;
    this.loadPatch();
  }

  onDestroy() {
    if (this.plane) {
      disposeMesh(this.plane);
      this.plane = null;
    }
  }

  // Called back when any inputs properties change like localPosition or localRotation
  onInputsUpdated() {
    if (this.plane) {
      disposeMesh(this.plane);
      this.plane = null;
    }
    this.onInit();
  }

  private loadPatch() {
    const THREE = this.context.three;
    const { url, opacity } = this.inputs;
    new THREE.TextureLoader().load(
      url,
      // onLoad callback
      (texture) => {
        try {
          if (texture != null && texture.isTexture) {
            const aspect = texture.image.width / texture.image.height;
            let width = 1;
            let height = 1;

            if (aspect > 1) {
              height /= aspect;
            } else if (aspect < 1) {
              width /= aspect;
            }

            const geometry = new THREE.PlaneGeometry(width, height);
            const material = new THREE.MeshBasicMaterial({
              transparent: true,
              opacity,
              map: texture,
            });
            this.plane = new THREE.Mesh(geometry, material);
            this.pivot.add(this.plane);
          }
        } catch (e) {
          console.log('[Err] An error happened during patch texture init.', e);
        }
      },
    );
  }
}

export const patchComponentType = 'mp.patchComponent';
export const makePatchComponent = (): any => new PatchComponent();
